import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
// import { ChooseIconComponent } from 'vhobjects-service';
// import { ChooseIconComponent } from '../../../../basic/icon/choose-icon/choose-icon.component';
import { ChooseIconComponent } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { FunctionService } from 'vhobjects-service/src/services';
import { ColorContrastComponent } from '../../../../../color-contrast/color-contrast.component';

@Component({
  selector: 'atw-btn-login-logout-2states-config',
  templateUrl: './btn-login-logout-2states-config.component.html',
  styleUrls: ['./btn-login-logout-2states-config.component.scss'],
})
export class AtwBtnLoginLogout2StatesConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isCollapsed: boolean = false;
  currentViewAll: any = {};
  dataAfterChange: any = {}; // lưu tên và style data để cập nhật vào database.
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  id_subproject: any;
  arr_link_page: any;
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = ''; // biến này lấy giá trị của màu rgb và alpha;
  isOpenOptionsBorder: boolean = false;
  fonts = []; // biến lưu danh sách fonts chữ trong cấu hình định dạng
  backgroundColor: any = [];
  customize = []
  dataBorder = [
    {
      name: 'solid',
      img_border: 'https://static.thenounproject.com/png/2264019-200.png',
    },
    {
      name: 'dashed',
      img_border: 'https://static.thenounproject.com/png/2264023-200.png',
    },
    {
      name: 'dotted',
      img_border: 'https://static.thenounproject.com/png/2449182-200.png',
    },
  ];
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung_chuyen_dong',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
  ];

  status = [
    {
      type: true,
      title: 'nut_dang_nhap',
    },
    {
      type: false,
      title: 'nut_dang_xuat',
    },
  ];
  effect_hover = []; // danh sách hiệu ứng trong mục Hiệu ứng khi rê chuột
  effect_hover_data: any = {};

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private dialog: MatDialog,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private matDialog: MatDialog,
  ) {}
  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`;
  };

  checkClass: any;
  ngOnInit(): void {
    this.checkClass = this.staticdata.type_item;
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/button.json'),
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/fonts/fonts.json'),
    ]).subscribe(([effects, background_colors, fonts]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
      this.backgroundColor = background_colors;
      this.effect_hover_data = this.effect_hover.find(
        (e) => e.type == this.staticdata[this.device + '_animation_type']
      );
    });
  }

  ngOnChanges(): void {
    if (!this.config.hasOwnProperty('duration_noti')) this.config['duration_noti'] = {};
    if (!this.staticdata.accessibility) this.staticdata.accessibility = {};
    
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.objectChoosing.isLogin) {
      if (this.config['+background-color'].gradient_check) {
        this.class['+btn-login-logout-2states'].background =
          'linear-gradient(' +
          this.config['+background-color']['gradient_arr'] +
          ')';
      } else {
        this.class['+btn-login-logout-2states'].background =
          this.config['+background-color']['background'];
      }
    } else {
      if (this.config['-background-color'].gradient_check) {
        this.class['-btn-login-logout-2states'].background =
          'linear-gradient(' +
          this.config['-background-color']['gradient_arr'] +
          ')';
      } else {
        this.class['-btn-login-logout-2states'].background =
          this.config['-background-color']['background'];
      }
    }
    this.updateObject();
  }
  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
        [this.device + '_config']: this.config,
        staticdata: this.staticdata,
      })
      .then((bool: any) => {
        
      });
  }
  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {
        
      });
  }

  /**
   *Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {
        
      });
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        
      });
  }
  /**
   * Hàm này thay đổi box-shadow giữa có hiệu ứng và không có hiệu ứng.
   * Khi gọi hàm này thì hiệu ứng hover hiển thị box-shadow sẽ bị disable.
   * Ngược lại thì thì hiệu ứng hover hiển thị box-shadow enable.
   */
  onChangeShadow() {
    const isLogin = this.objectChoosing.isLogin;
    const shadowConfig = isLogin
      ? this.config['+box-shadow']
      : this.config['-box-shadow'];

    if (!shadowConfig['shadow_check']) {
      shadowConfig['offset_x'] = 0;
      shadowConfig['offset_y'] = 0;
      shadowConfig['blur_radius'] = 0;
      shadowConfig['shadow_color'] = '#333';
    }

    this.class[
      isLogin ? '+btn-login-logout-2states' : '-btn-login-logout-2states'
    ][
      'box-shadow'
    ] = `${shadowConfig['offset_x']}px ${shadowConfig['offset_y']}px ${shadowConfig['blur_radius']}px ${shadowConfig['shadow_color']}`;
  }

  /**
   * remove link khi click vào nút x
   */
  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData();
  }
  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /**Xử lý lấy thông số giá trị background color.
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundColor(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    // Tính giá trị alpha cho màu rgb.
    const data =
      this.checkClass === 'login'
        ? this.class['btn-login-logout-2states']
        : this.class['-btn-login-logout-2states'];
    // Nối chuỗi màu + độ mờ (alpha) và lưu vào database.
    this.style_color = `rgba(${this.hexToRGB(data.background)}, ${
      this.config['background-color']['value_range'] / 100
    })`;
    data.background_rgb = this.style_color;
    this.updateClass();
  }
  /**Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    if (this.objectChoosing.isLogin) {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] = this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      // Tách các phần tử màu từ chuỗi rgba.
      const newArr = this.config['background-color'].gradient_arr.map(
        (color) => {
          const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
          return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
        }
      );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].gradient_arr = newArr;
      this.updateBackgroundRgb();
    } else {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] = this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      const newArr = this.config['background-color'].gradient_arr.map(
        (color) => {
          // Tách các phần tử màu từ chuỗi rgba
          const parts = color.match(/(\d+(\.\d+)?)/g);
          return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
        }
      );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].gradient_arr = newArr;
      this.updateClass();
    }
  }
  /** Hàm này lấy giá trị màu nền của input color
   * @param event : trả về màu được chọn từ input color
   */
  updateColorInput(e) {
    const value_color = e.target.value;
    const data_login = this.class['btn-login-logout-2states'];
    const data_logout = this.class['-btn-login-logout-2states'];
    // Chuyển đổi chuổi màu hexadecimal thành rgb
    // Nối chuỗi rgb + giá trị alpha và cập nhật lưu vào database.
    if (this.objectChoosing.staticdata.type_item === 'login') {
      this.style_color = `rgba(${this.hexToRGB(value_color)}, ${
        this.config['background-color']['value_range']
      })`;
      data_login.background_rgb = this.style_color;
      this.updateClass();
    } else {
      this.style_color = `rgba(${this.hexToRGB(value_color)}, ${
        this.config['background-color']['value_range']
      })`;
      data_logout.background_rgb = this.style_color;

      this.updateClass();
    }
  }
  /**Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      // Lấy ra element màu được click từ tham số event trả về.
      var activeGradient = document.querySelector(
        '.container-color .active'
      ) as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Lấy giá trị màu được click từ tham số bgColor.
      //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
      if (this.objectChoosing.isLogin) {
        const data_background = this.class['+btn-login-logout-2states'];
        data_background['background-color'] = bgColor.bgColor;
        data_background['background-color'] = `rgba(${this.hexToRGB(
          data_background['background-color']
        )}, ${this.config['+background-color'].value_range})`;
      } else {
        const data_background = this.class['-btn-login-logout-2states'];
        data_background['background-color'] = bgColor.bgColor;
        data_background['background-color'] = `rgba(${this.hexToRGB(
          data_background['background-color']
        )}, ${this.config['-background-color'].value_range})`;
      }
      this.updateObject();
    }
    this.updateObject();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      if (this.objectChoosing.isLogin) {
        this.config['+background-color'].gradient_type = direction.type;
        this.config['+background-color'].gradient_direction = direction.direction;
        this.class['+btn-login-logout-2states']['background'] =
          this.config['+background-color'].gradient_type +
          '(' +
          this.config['+background-color'].gradient_direction +
          this.config['+background-color'].gradient_arr.join(',') +
          ')';
        this.updateObject();
      } else {
        this.config['-background-color'].gradient_type = direction.type;
        this.config['-background-color'].gradient_direction = direction.direction;
        this.class['-btn-login-logout-2states']['background'] =
          this.config['-background-color'].gradient_type +
          '(' +
          this.config['-background-color'].gradient_direction +
          this.config['-background-color'].gradient_arr.join(',') +
          ')';
        this.updateObject();
      }
    }
  }
  /** Xử lý border
   */
  toggleBorder(isActive) {
    if (this.objectChoosing.isLogin) {
      const active = this.class['+btn-login-logout-2states'];
      active.check_border = isActive;
      active.check_border_top = isActive;
      active.check_border_bottom = isActive;
      active.check_border_right = isActive;
      active.check_border_left = isActive;
    } else {
      const active = this.class['-btn-login-logout-2states'];
      active.check_border = isActive;
      active.check_border_top = isActive;
      active.check_border_bottom = isActive;
      active.check_border_right = isActive;
      active.check_border_left = isActive;
    }
    this.updateClass();
  }

  openbgGradient() {
    if (isPlatformBrowser(this.platformId))  document.getElementById('input-gradient').click();
  }
  /** Hàm này dùng để mở dialog của component icon
   */
  openDialogChooseIcon() {
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const iconConfig = this.objectChoosing.isLogin
          ? this.config['+flex-direction']
          : this.config['-flex-direction'];
        iconConfig.icon_name = result.icon;
        this.updateConfig();
      }
    });
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient = this.objectChoosing.isLogin
        ? this.config['+background-color']
        : this.config['-background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.objectChoosing.isLogin) {
      if (this.config['+background-color'][`gradient_arr`].length > 1) {
        this.config['+background-color'][`gradient_arr`].splice(index, 1);
        this.updateBackgroundRgb();
      }
    } else {
      if (this.config['-background-color'][`gradient_arr`].length > 1) {
        this.config['-background-color'][`gradient_arr`].splice(index, 1);
        this.updateBackgroundRgb();
      }
    }
  }
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * update trường mobile_portrait_hidden or desktop_hidden cho object
   * @param value
   */
  updateHidden(value) {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, value).then(
      (bool) => {
        
      },
      (error) => {
        console.error(error);
      }
    );
  }
  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[2]);
  }

  /**
   * Mở popup so sánh màu nền và màu chữ có tương phản hay không
   * (Để tối ưu Accessibility trong SEO)
   */
  openColorContrast() {
    const colorClass = this.class['btn-login-logout-2states__content'].color ? 'btn-login-logout-2states__content' : 'btn-login-logout-2states';
    const dialogRef = this.matDialog.open(ColorContrastComponent, {
      width: '30vw',
      height: 'fit-content',
      data: {
        /** Chứa map màu nền và màu chữ/icon */
        colorContrast: {
          typeFgColor: 'text',
          textOrIconColor: this.class[colorClass].color,
          bgColor: this.class['btn-login-logout-2states']['background-color'],
        }
      },
    });

    dialogRef.afterClosed().subscribe((colorContrast) => {
      if (colorContrast) {
        this.class[colorClass].color = colorContrast.textOrIconColor;
        this.class['btn-login-logout-2states']['background-color'] = colorContrast.bgColor;
        this.updateClass();
      }
    });
  }
}
